<template>
  <a-modal
    :open="open"
    class="manager-resident-cluster-modal"
    :footer="null"
    :closable="true"
    :mask-closable="true"
    centered
    width="480px"
    @cancel="emit('update:open', false)"
  >
    <h3 class="manager-resident-cluster-modal__title">Изменить кластер</h3>
    <p class="manager-resident-cluster-modal__description">
      Выберите кластер в который будет входить резидент.
    </p>

    <a-divider class="manager-resident-cluster-modal__divider" />

    <a-form layout="vertical" class="manager-resident-cluster-modal__form">
      <a-form-item label="Кластер" class="stc-ant-field-skin">
        <a-select
          v-model:value="draftClusterId"
          placeholder="Выберите кластер"
          :options="clusterOptions"
        />
      </a-form-item>
    </a-form>

    <a-divider class="manager-resident-cluster-modal__divider" />

    <div class="manager-resident-cluster-modal__actions">
      <button
        type="button"
        class="btn btn-secondary btn-medium"
        @click="emit('update:open', false)"
      >
        Отмена
      </button>
      <button
        type="button"
        class="btn btn-primary btn-medium"
        :disabled="isSelectDisabled || saving"
        @click="handleSelect"
      >
        {{ saving ? 'Сохранение...' : 'Выбрать' }}
      </button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import type { ManagerResidentsClusterOption } from './types';

const props = defineProps<{
  open: boolean;
  clusterId: string;
  clusters: ManagerResidentsClusterOption[];
  saving?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void;
  (e: 'select', clusterId: string): void;
}>();

const draftClusterId = ref<string | undefined>(undefined);

const clusterOptions = computed(() =>
  props.clusters.map((cluster) => ({
    value: cluster.id,
    label: cluster.name,
  })),
);

const isSelectDisabled = computed(
  () => !draftClusterId.value || draftClusterId.value === props.clusterId,
);

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) return;
    draftClusterId.value = props.clusterId || undefined;
  },
);

function handleSelect() {
  if (!draftClusterId.value || isSelectDisabled.value) return;
  emit('select', draftClusterId.value);
}
</script>
